import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { styled } from '@flex-design-system/stitches-react';

const alignOptions = {
  start: {
    alignItems: "flex-start"
  },
  unset: {
    alignItems: "unset"
  },
  normal: {
    alignItems: "normal"
  },
  center: {
    alignItems: "center"
  },
  "flex-end": {
    alignItems: "flex-end"
  },
  stretch: {
    alignItems: "stretch"
  },
  baseline: {
    alignItems: "baseline"
  }
};
const justifyOptions = {
  stretch: {
    justifyContent: "stretch"
  },
  start: {
    justifyContent: "flex-start"
  },
  center: {
    justifyContent: "center"
  },
  "flex-end": {
    justifyContent: "flex-end"
  },
  "space-between": {
    justifyContent: "space-between"
  }
};
const directionOptions = {
  row: {
    flexDirection: "row"
  },
  column: {
    flexDirection: "column"
  },
  rowReverse: {
    flexDirection: "row-reverse"
  },
  columnReverse: {
    flexDirection: "column-reverse"
  }
};
const FlexInternal = forwardRef(
  ({ elementType, ...props }, ref) => {
    return /* @__PURE__ */ jsx(StyledFlex, { ref, as: elementType, ...props });
  }
);
const StyledFlex = styled("div", {
  display: "flex",
  variants: {
    align: alignOptions,
    justify: justifyOptions,
    direction: directionOptions,
    wrap: {
      noWrap: {
        flexWrap: "nowrap"
      },
      wrap: {
        flexWrap: "wrap"
      },
      wrapReverse: {
        flexWrap: "wrap-reverse"
      }
    }
  },
  defaultVariants: {
    direction: "row",
    align: "start",
    justify: "start",
    wrap: "noWrap"
  }
});
const FlexCenter = forwardRef((props, ref) => /* @__PURE__ */ jsx(FlexInternal, { ref, align: "center", justify: "center", ...props }));
const FlexAlignCenter = forwardRef((props, ref) => /* @__PURE__ */ jsx(FlexInternal, { ref, align: "center", ...props }));
const FlexJustifyCenter = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(FlexInternal, { ref, justify: "center", ...props })
);
const FlexColumn = forwardRef((props, ref) => /* @__PURE__ */ jsx(FlexInternal, { ref, direction: "column", ...props }));
const FlexRow = forwardRef((props, ref) => /* @__PURE__ */ jsx(FlexInternal, { ref, direction: "row", ...props }));
const Flex = FlexInternal;
Flex.Center = FlexCenter;
Flex.AlignCenter = FlexAlignCenter;
Flex.JustifyCenter = FlexJustifyCenter;
Flex.Column = FlexColumn;
Flex.Row = FlexRow;

export { Flex as default };
//# sourceMappingURL=flex.mjs.map
